/* ============================================================================
   TradeSwapIcon — b17z-ui item 4.

   Replaces the lucide Wand2 on the Trade tab with a custom "swap" mark that
   reads like the PoGo trade logo: two small pokeball discs (each bisected by a
   horizontal band) with two curved arrows arcing between them — one over the
   top pointing right, one under the bottom pointing left.

   Stroke-based so it inherits `currentColor`; the .tabbar-item__icon rules then
   drive its colour on active/inactive states exactly like the lucide icons
   (Users / User / Calendar). Prop interface matches lucide-react (className +
   strokeWidth) so it is plug-compatible in TabBar's renderTab.
   ============================================================================ */
import type { SVGProps } from "react";

interface TradeSwapIconProps extends SVGProps<SVGSVGElement> {
  strokeWidth?: number | string;
}

export function TradeSwapIcon({ strokeWidth = 2, ...props }: TradeSwapIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {/* Left pokeball: disc + bisecting band. */}
      <circle cx="5.5" cy="6.5" r="3.5" />
      <line x1="2" y1="6.5" x2="9" y2="6.5" />
      {/* Right pokeball: disc + bisecting band. */}
      <circle cx="18.5" cy="17.5" r="3.5" />
      <line x1="15" y1="17.5" x2="22" y2="17.5" />
      {/* Top arrow: arcs from the left ball over to the right, pointing right. */}
      <path d="M9.5 6.5h5.5a3 3 0 0 1 3 3v1.5" />
      <path d="M15.5 14.5l2.5-2.5 2.5 2.5" />
      {/* Bottom arrow: arcs from the right ball back to the left, pointing left. */}
      <path d="M14.5 17.5H9a3 3 0 0 1-3-3v-1.5" />
      <path d="M8.5 9.5L6 12l-2.5-2.5" />
    </svg>
  );
}

export default TradeSwapIcon;
